const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAFFFF"
    },
    d: "M445.217,489.739H66.783c-24.588,0-44.522-19.934-44.522-44.522V66.783 c0-24.588,19.933-44.522,44.522-44.522h378.435c24.588,0,44.522,19.933,44.522,44.522v378.435 C489.739,469.806,469.806,489.739,445.217,489.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9D5BB"
    },
    d: "M512,322.783v166.957c0,12.295-9.966,22.261-22.261,22.261H22.261C9.966,512,0,502.034,0,489.739 V381.217h133.565L512,322.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF81"
    },
    d: "M189.217,94.609c0,52.251-42.358,94.609-94.609,94.609S0,146.859,0,94.609S42.358,0,94.609,0 S189.217,42.358,189.217,94.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF145"
    },
    d: "M144.696,94.609c0,27.662-22.424,50.087-50.087,50.087s-50.087-22.424-50.087-50.087 s22.424-50.087,50.087-50.087S144.696,66.946,144.696,94.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#84837A"
    },
    d: "M72.348,294.957c0,4.61-3.738,8.348-8.348,8.348c-10.74,0-19.478,8.739-19.478,19.478 c0,4.61-3.738,8.348-8.348,8.348s-8.348-3.738-8.348-8.348c0-10.74-8.739-19.478-19.478-19.478c-4.61,0-8.348-3.738-8.348-8.348 s3.738-8.348,8.348-8.348c11.176,0,21.186,5.096,27.826,13.084c6.64-7.988,16.65-13.084,27.826-13.084 C68.61,286.609,72.348,290.346,72.348,294.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBCB9C"
    },
    d: "M478.609,22.261v100.174V244.87H378.435v122.435h-256V244.87h89.043V122.435h133.565V22.261H478.609z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#998C6E"
    },
    d: "M219.826,300.522c0,4.61-3.738,8.348-8.348,8.348h-55.652c-4.61,0-8.348-3.738-8.348-8.348 s3.738-8.348,8.348-8.348h55.652C216.088,292.174,219.826,295.911,219.826,300.522z M311.652,169.739H256 c-4.61,0-8.348,3.738-8.348,8.348c0,4.61,3.738,8.348,8.348,8.348h55.652c4.61,0,8.348-3.738,8.348-8.348 C320,173.477,316.262,169.739,311.652,169.739z M400.696,169.739h-55.652c-4.61,0-8.348,3.738-8.348,8.348 c0,4.61,3.738,8.348,8.348,8.348h55.652c4.61,0,8.348-3.738,8.348-8.348C409.043,173.477,405.306,169.739,400.696,169.739z  M434.087,64h-44.522c-4.61,0-8.348,3.738-8.348,8.348s3.738,8.348,8.348,8.348h44.522c4.61,0,8.348-3.738,8.348-8.348 S438.697,64,434.087,64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7039"
    },
    d: "M378.435,244.87L378.435,244.87v44.522h-77.913V267.13H111.304c-12.295,0-22.261-9.966-22.261-22.261 l0,0c0-12.295,9.966-22.261,22.261-22.261h244.87C368.469,222.609,378.435,232.575,378.435,244.87z M489.739,100.174H200.348 c-12.295,0-22.261,9.966-22.261,22.261l0,0c0,12.295,9.966,22.261,22.261,22.261h289.391c12.295,0,22.261-9.966,22.261-22.261l0,0 C512,110.14,502.034,100.174,489.739,100.174z M489.739,0H333.913c-12.295,0-22.261,9.966-22.261,22.261l0,0 c0,12.295,9.966,22.261,22.261,22.261h155.826c12.295,0,22.261-9.966,22.261-22.261l0,0C512,9.966,502.034,0,489.739,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB961"
    },
    d: "M300.522,389.565H66.783l0,0c0-24.588,19.933-44.522,44.522-44.522h189.217V389.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CEA455"
    },
    d: "M473.414,381.217c0,4.61-3.738,8.348-8.348,8.348H8.348c-4.61,0-8.348-3.738-8.348-8.348 s3.738-8.348,8.348-8.348h456.718C469.678,372.87,473.414,376.607,473.414,381.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAFFFF"
    },
    d: "M370.087,439.652h-244.87c-4.61,0-8.348-3.738-8.348-8.348s3.738-8.348,8.348-8.348h244.87 c4.61,0,8.348,3.738,8.348,8.348S374.697,439.652,370.087,439.652z M91.826,422.957H36.174c-4.61,0-8.348,3.738-8.348,8.348 s3.738,8.348,8.348,8.348h55.652c4.61,0,8.348-3.738,8.348-8.348S96.436,422.957,91.826,422.957z M386.783,463.768h-244.87 c-4.61,0-8.348,3.738-8.348,8.348c0,4.61,3.738,8.348,8.348,8.348h244.87c4.61,0,8.348-3.738,8.348-8.348 C395.13,467.506,391.393,463.768,386.783,463.768z M475.826,463.768h-55.652c-4.61,0-8.348,3.738-8.348,8.348 c0,4.61,3.738,8.348,8.348,8.348h55.652c4.61,0,8.348-3.738,8.348-8.348C484.174,467.506,480.436,463.768,475.826,463.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FBA41"
    },
    d: "M512,237.449v107.595c0,24.588-19.933,44.522-44.522,44.522H289.391 c-24.588,0-44.522-19.933-44.522-44.522v-40.812c0-26.637,21.594-48.232,48.232-48.232l0,0c14.919,0,28.255,6.777,37.101,17.417 v-2.577c0.001-26.637,21.595-48.231,48.233-48.231l0,0c14.919,0,28.255,6.777,37.101,17.417v-2.577 c0-26.637,21.594-48.232,48.232-48.232l0,0C490.406,189.217,512,210.812,512,237.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F932A"
    },
    d: "M512,300.517v42.588c0,25.659-20.826,46.46-46.516,46.46H279.417c-0.21,0-0.421-0.001-0.631-0.004 c-41.284-0.549-46.642-59.707-6.31-68.522c3.484-0.761,7.103-1.163,10.817-1.163l0,0c15.588,0,29.52,7.072,38.764,18.176v-2.689 c0-27.797,22.561-50.332,50.393-50.332l0,0c15.588,0,29.52,7.072,38.764,18.176v-2.689c0-27.797,22.561-50.332,50.393-50.332l0,0 C489.439,250.185,512,272.72,512,300.517z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResort);
export default __webpack_public_path__ + "static/media/resort.6bda1bd9fd35f989659d3d246307d7ea.svg";
export { ForwardRef as ReactComponent };